import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/minimal/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

import axios from 'axios';
import cookie from 'js-cookie';

let axiosOptions = {
  baseURL: process.env.VUE_APP_BASE_URL_API,
  timeout: 180000, // 3 menit
  headers: {
    Authorization: 'Bearer',
    'Content-Type': 'application/json',
    'X-timezone': 'Asia/Jakarta',
    'Accept': 'application/json'
  }
};

if (cookie.getJSON('userdata') !== undefined) {
  let auth = cookie.getJSON('userdata')
  store.commit('auth/SET_CURRENT_USER', auth) 
  axiosOptions.headers.Authorization = 'Bearer ' + auth.token
}


const axiosInstance = axios.create(axiosOptions);

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);



AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueApexCharts);
app.use(BootstrapVueNext);
app.component(VueFeather.type, VueFeather);
app.directive("maska", vMaska);
app.use(i18n);
app.use(VueSweetalert2);
app.use(vClickOutside);

app.config.globalProperties.$axios = axiosInstance;

app.mount('#app');